// extracted by mini-css-extract-plugin
export var actionButton = "_dq-0";
export var attachmentLine = "_dq-1";
export var fileInput = "_dq-2";
export var fileUploadWrapper = "_dq-4";
export var footer = "_dq-3";
export var modalContent = "_dq-5";
export var paperclip = "_dq-6";
export var quillEditor = "_dq-7";